<template>
  <v-container
    grid-list-xl
    fluid
    style="padding-top: 0;">
    <v-layout wrap>
      <v-flex md12>
        <material-card
          :title="$t('templateEmail.list')"
          color="green"
          flat
          full-width
        >
          <template>
            <v-btn
              v-if="!isEntityDisabled()"
              color="success"
              dark
              style="float: right;"
              @click="createNewTemplateEmail"
            >
              <v-icon class="mr-2">mdi-text-box-plus-outline</v-icon>
              <span style="text-transform: none;">{{
                $t('templateEmail.createNew')
              }}</span>
            </v-btn>
            <v-btn
              color="error"
              dark
              style="float: right;"
              @click="onClose"
            >
              <v-icon class="mr-2">mdi-close</v-icon>
              <span style="text-transform: none;">{{
                $t('common.close')
              }}</span>
            </v-btn>
          </template>
          <v-data-table
            :no-data-text="$t('common.noDataAvailable')"
            :headers="templateEmailHeaders"
            :items="templateEmailList"
            :single-select="true"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="text--darken-3 font-medium"
                v-text="$t(header.text)"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }">
              <td
                v-for="(header, index) in templateEmailHeaders"
                :key="header.value + index"
              >
                <div v-if="header.value == 'usedDefault'">
                  <v-tooltip
                    v-if="!item[header.value]"
                    top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="error"
                        dark
                        v-on="on">mdi-close-outline</v-icon>
                    </template>
                    <span>{{ $t('evoucher.state.inactive') }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-else
                    top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="success"
                        dark
                        v-on="on">mdi-check-outline</v-icon>
                    </template>
                    <span>{{ $t('evoucher.state.active') }}</span>
                  </v-tooltip>
                </div>
                <div v-else-if="header.value == 'actions'">
                  <!-- Update template -->
                  <v-tooltip
                    v-if="!item['usedDefault']"
                    top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :disabled="isEntityDisabled()"
                        class="mx-2"
                        fab
                        small
                        color="indigo"
                        style="color: #ffffff;"
                        v-on="on"
                        @click="useThisTemplate(item['id'])"
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("templateEmail.usedThisTemplate") }}</span>
                  </v-tooltip>
                  <!-- Update template -->
                  <v-tooltip
                    top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        color="primary"
                        style="color: #ffffff;"
                        v-on="on"
                        @click="updateTemplateEmail(item['id'])"
                      >
                        <v-icon>mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("common.update") }}</span>
                  </v-tooltip>
                  <!-- Delete template -->
                  <v-tooltip
                    top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :disabled="isEntityDisabled()"
                        class="mx-2"
                        fab
                        small
                        color="error"
                        style="color: #ffffff;"
                        v-on="on"
                        @click="onShowModalConfirmDelete(item['id'])"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("common.delete") }}</span>
                  </v-tooltip>
                </div>
                <span v-else>{{ item[header.value] }}</span>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <pagination
      :total="paginate.totalPage"
      :current-page="paginate.currentPage"
      :row-per-page="paginate.rowPerPage"
      @onPageChange="onPageChange"
    />
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    />
    <loading-bar :is-loading="isLoading" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ToastType from 'enum/toastType'
import functionUtils from 'utils/functionUtils'
export default {
  components: {},
  data: () => ({
    templateEmailHeaders: [
      { sortable: false, text: 'common.nonumber', value: 'stt' },
      { sortable: false, text: 'templateEmail.name', value: 'name' },
      { sortable: false, text: 'templateEmail.usedDefault', value: 'usedDefault' },
      { sortable: false, text: 'templateEmail.category.title', value: 'category' },
      // { sortable: false, text: 'Nhà cung cấp', value: 'supplier' },
      { sortable: false, text: 'common.actions', value: 'actions' }
    ],
    templateEmailList: [],
    paginate: {
      totalPage: 1,
      currentPage: 1,
      rowPerPage: 1
    },
    isLoading: false
  }),
  computed: {
    ...mapGetters([
      'TEMPLATE_EMAIL_DATA',
      'GET_SNACK_BAR',
      'GET_CURRENT_ACCOUNT'
    ])
  },
  watch: {
    TEMPLATE_EMAIL_DATA () {
      let res = this.TEMPLATE_EMAIL_DATA
      // Handle paginate
      this.paginate.currentPage = res.paginate.currentPage
      this.paginate.totalPage = res.paginate.totalPage
      this.paginate.rowPerPage = res.paginate.perPage / 2
      // Handle response data
      let templateEmailData = res.results
      this.templateEmailList = []
      for (let i = 0, size = templateEmailData.length; i < size; i++) {
        let obj = {
          stt: i + 1 + (res.paginate.currentPage - 1) * res.paginate.pageSize,
          id: templateEmailData[i].id,
          name: templateEmailData[i].name,
          category: templateEmailData[i].category.name,
          usedDefault: templateEmailData[i].used_default
          // supplier: templateEmailData[i].entity && templateEmailData[i].entity.name
        }
        this.templateEmailList.push(obj)
      }
    }
  },
  created () {
    this.getTemplateEmailList()
    // if (!this.isAdmin()) {
    // this.templateEmailHeaders = this.templateEmailHeaders.filter(element => {
    //   return element.value !== 'supplier'
    // })
    // }
  },
  methods: {
    /**
     * Check admin role
     */
    isAdmin: function () {
      return functionUtils.isAdmin(this.GET_CURRENT_ACCOUNT)
    },
    isEntityDisabled: function () {
      return functionUtils.isCurrentEntityLocked() || functionUtils.isCurrentEntityExpired()
    },
    /**
     * Show modal confirm delete
     */
    onShowModalConfirmDelete: function (id) {
      this.$confirmMatch({
        message: 'Bạn có chắc chắn muốn xoá mẫu email này?',
        matchText: 'DELETE',
        onConfirm: () => {
          this.onConfirmDeleted(id)
        }
      });
    },
    /**
     * Confirm delete
     */
    onConfirmDeleted: function (templateId) {
      this.DELETE_TEMPLATE_EMAIL({ id: templateId }).then(
        function () {
          this.ON_SHOW_TOAST({
            message: this.$t('server.common.successed'),
            styleType: ToastType.SUCCESS
          })
          this.getTemplateEmailList()
        }.bind(this)
      )
    },
    /**
     * Use this template
     */
    useThisTemplate: function (id) {
      let templateCategoryId = this.$route.params.id
      let filter = {
        usedTemplate: true,
        categoryId: templateCategoryId
      }
      this.UPDATE_TEMPLATE_EMAIL({ id: id, ...filter }).then(
        function () {
          this.getTemplateEmailList()
        }.bind(this)
      )
    },
    /**
     * Update template email
     */
    updateTemplateEmail: function (id) {
      let templateCategoryId = this.$route.params.id
      this.$router.push({
        path: `/update-template-email/${id}/${templateCategoryId}`,
        params: {
          templateId: id,
          categoryId: templateCategoryId
        }
      })
    },
    /**
     * Go back
     */
    onClose: function () {
      window.history.back()
    },
    /**
     * Create new template email
     */
    createNewTemplateEmail: function () {
      if (this.isEntityDisabled()) {
        return // Locked or expired entity will not able to perform these actions
      }
      let categoryId = this.$route.params.id
      this.$router.push({
        'path': `/create-template-email/${categoryId}`,
        params: {
          categoryId: categoryId
        }
      })
    },
    /**
     * Get template email list
     */
    getTemplateEmailList: function () {
      let templateCategoryId = this.$route.params.id
      let filter = {
        params: {
          page: this.paginate.currentPage,
          categoryId: templateCategoryId
        }
      }
      this.isLoading = true
      this.GET_TEMPLATE_EMAIL(filter).then(
        function () {
          this.isLoading = false
        }.bind(this)
      ).catch(
        function () {
          this.isLoading = false
        }.bind(this)
      )
    },
    /**
     * Page change
     */
    onPageChange: function (page) {
      this.paginate.currentPage = page
      this.getTemplateEmailList()
    },
    ...mapActions([
      'GET_TEMPLATE_EMAIL',
      'UPDATE_TEMPLATE_EMAIL',
      'DELETE_TEMPLATE_EMAIL',
      'ON_SHOW_TOAST'
    ])
  }
}
</script>

<style></style>
